import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WebServiceWorker } from './services';
import { UpdateWorkerComponent } from './shared/components/update-worker/update-worker.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
  standalone: true,
  imports: [RouterOutlet, UpdateWorkerComponent],
})
export class App {
  private webServiceWorker = inject(WebServiceWorker);
  protected readonly title = signal('portal-asistencia');

  isNewAppVersionAvailable: boolean = false;
  newAppUpdateAvailableSubscription: any;

  ngOnInit(): void {
    this.checkIfAppUpdated();
  }

  checkIfAppUpdated() {
    this.newAppUpdateAvailableSubscription =
      this.webServiceWorker.$isAnyNewUpdateAvailable.subscribe((versionAvailableFlag: boolean) => {
        console.log('isNewAppVersionAvailable: ', this.isNewAppVersionAvailable);
        this.isNewAppVersionAvailable = versionAvailableFlag;
      });
  }

  refreshApp() {
    this.webServiceWorker.swUpdate.activateUpdate().then(() => document.location.reload());
  }

  ngOnDestroy() {
    if (this.newAppUpdateAvailableSubscription) {
      this.newAppUpdateAvailableSubscription.unsubscribe();
    }
  }
}
